// extracted by mini-css-extract-plugin
export default {"container":"login_container__jMCWl","form":"login_form__TytGG"};